import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Self,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, FormGroupDirective, NgControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { distinctUntilChanged, tap } from 'rxjs/operators';

import { CustomControlAbstract } from '@app/components/abstract/custom-control.abstract';
import { EIcon } from '@shared/enums/icon.enum';

@UntilDestroy()
@Component({
  selector: 'app-custom-color-picker',
  templateUrl: './custom-color-picker.component.html',
  styleUrls: ['./custom-color-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomColorPickerComponent
  extends CustomControlAbstract<any>
  implements OnInit, OnDestroy, ControlValueAccessor
{
  readonly labelOutsideDefaultCss = 'nowrap body-small-bold';

  @Input() selectCss = 'body-small text-color dark';
  @Input() set labelCss(value: string) {
    this._labelCss = value;
  }
  get labelCss(): string {
    if (this._labelCss) return this._labelCss;

    return this.labelOutsideDefaultCss;
  }

  private _valueCss: string;
  @Input() set valueCss(value) {
    this._valueCss = value;
  }
  get valueCss() {
    if (this._valueCss) {
      return this._valueCss;
    }
    return 'ellipsis text-color dark body-small';
  }
  @Input() containerCss = 'display-flex align-items-center';
  @Input() label = '';
  @Input() icon: EIcon;
  @Input() iconCss = 'dropdown-icon';
  @Input() iconTooltip = '';
  @Input() attrPlaceholder = '';
  @Input() attrDisable = false;
  @Input() markAsInvalid = false;
  @Input() errorSection = true;

  _labelCss = '';
  _labelElement: ElementRef<HTMLElement>;

  @ViewChild('labelElement', { static: false }) set content(value: ElementRef<HTMLElement>) {
    if (!value) return;

    this._labelElement = value;
    this.cdr.detectChanges();
  }

  constructor(
    @Self() @Optional() protected ngControl: NgControl,
    protected cdr: ChangeDetectorRef,
    @Optional() formDirective: FormGroupDirective
  ) {
    super(ngControl, cdr, formDirective);
  }

  ngOnInit(): void {
    this.initControlBase();

    this.control.valueChanges
      .pipe(
        untilDestroyed(this),
        distinctUntilChanged(),
        tap(value => this.onChanged(value))
      )
      .subscribe();
  }

  writeValue(value: any): void {
    if (value != this.control.value) {
      this.control.setValue(value);
    }
  }

  ngOnDestroy(): void {}
}
